import { useQuery } from '@tanstack/react-query';
import { queryKeys } from 'queryKeys';
import userService from 'services/user';

export function useAcpoAccountsQuery(enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.layout.acpoAccounts(),
    queryFn: () => userService.getAcpoAccounts(),
    staleTime: 5 * 60 * 1000,
    enabled
  });
}
